import { render, staticRenderFns } from "./pageCard.vue?vue&type=template&id=699ea0ee&scoped=true&"
import script from "./pageCard.vue?vue&type=script&lang=js&"
export * from "./pageCard.vue?vue&type=script&lang=js&"
import style0 from "./pageCard.vue?vue&type=style&index=0&id=699ea0ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699ea0ee",
  null
  
)

export default component.exports